import React, {useState} from 'react';
import Search from "../search/search";
import {DeleteIcon, EditIcon, MailIcon, RedCloseIcon} from "../../icons/icons";
import Pagination from "../pagination/pagination";
import DropDown from "../../assets/dropDown/dropDown";
import Sort from "../sort/sort";
import {GetViewType} from "../../utils/view-type";
import Filter from "../filter/filter";
import {useTranslation} from "react-i18next";
import {CONST} from "../../utils/CONST";
import {useSelector} from "react-redux";

const VisaTableHistory = () => {
  const viewType = GetViewType()
  const {t} = useTranslation();
  const [idModal, setIdModal] = useState(false)
  const [searchTime, setSearchTime] = useState("")
  const lng = useSelector((state) => state.common.lng)

  const data = [
    {name: ' 10 روز تا انقضا', row: 121, status: 1, eg: "151651616561", code: 'پروانه اقامت 3ماهه', city: ["رضا شیخ لواسانی" , "علی رحماندوست","علیرضا احمدی نژاد"] , date:"1403/12/18"},
    {name: ' 10 روز تا انقضا', row: 121, status: 2, eg: "151651616561", code: 'پروانه اقامت 3ماهه', city: ["رضا شیخ لواسانی" , "علی رحماندوست"] , date:"1403/12/18"},
    {name: ' 10 روز تا انقضا', row: 121, status: 3, eg: "151651616561", code: 'پروانه اقامت 3ماهه', city: ["رضا شیخ لواسانی" , "علی رحماندوست","علیرضا احمدی نژاد"] , date:"1403/12/18"},
    {name: ' 10 روز تا انقضا', row: 121, status: 1, eg: "151651616561", code: 'پروانه اقامت 3ماهه', city: ["رضا شیخ لواسانی" , "علی رحماندوست","علیرضا احمدی نژاد"] , date:"1403/12/18"},
    {name: ' 10 روز تا انقضا', row: 121, status: 4, eg: "151651616561", code: 'پروانه اقامت 3ماهه', city: ["رضا شیخ لواسانی" , "علی رحماندوست","علیرضا احمدی نژاد"] , date:"1403/12/18"},

  ];
  const handleStatus = (status) => {
    let find = CONST.status.find((item) => {
      return item.id === status
    })
    return(
      <div className={`rounded-lg text-center py-2 text-green-200 bg-green-100 text-[8px] md:text-xs w-full md:w-[86px]`}>
        {find[`${lng}`]}
      </div>
    )
  }
  const handleSearch = (e) => {

    clearTimeout(searchTime)


    let loop = setTimeout(() => {


    }, 1000)
    setSearchTime(loop)

  }
  const handleSort = (e) => {
    // setData([])
    setTimeout(() => {
      // setData(e)
    } ,0)
  }
  return (
    <div className={"my-container"}>
      {
        viewType === "WEB" ?
          <div
            className="relative overflow-x-auto w-full  bg-white rounded-lg  flex flex-col items-center w-full !mt-5 border border-1 border-gray-300 overflow-hidden ">
            <table className="w-full text-sm text-gray-500">
              <thead className="text-xs text-gray-700 uppercase ">
              <tr className={"border-b border-gray-400"}>
                <th scope="col" className="px-6 py-3 text-left w-4 font-normal text-gray-600 text-sm">
                  <div className={"mt-1"}>
                    {t("row")}
                  </div>
                </th>
                <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm">
                  <div className={"mt-1 flex "}>
                    <Sort data={data} sortKey={"price"}  onSort={(e)=> handleSort(e)}/>
                    {t("visaType")}
                  </div>
                </th>

                <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm">
                  <div className={"mt-1 justify-center flex"}>
                    <Sort data={data} sortKey={"price"}  onSort={(e)=> handleSort(e)}/>
                    {t("automationNumber")}
                  </div>
                </th>
                <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm">
                  <div className={"mt-1 flex flex justify-center"}>
                    <Sort data={data} sortKey={"price"}  onSort={(e)=> handleSort(e)}/>
                    {t("requestDate")}
                  </div>
                </th>
                <th scope="col" className=" py-3  text-right font-normal text-gray-600 text-sm">
                  <div className={"mt-1 flex flex justify-center"}>
                    <Sort data={data} sortKey={"price"}  onSort={(e)=> handleSort(e)}/>
                    {t("startDate")}
                  </div>
                </th>
                <th scope="col" className=" py-3 mx-auto text-center font-normal text-gray-600 text-sm">
                  <div className={"mt-1 flex justify-center"}>
                    <Sort data={data} sortKey={"price"}  onSort={(e)=> handleSort(e)}/>
                    {t("status")}
                  </div>
                </th>
                <th scope="col" className=" py-3  text-center font-normal text-gray-600 text-sm">
                  <div className={"mt-1 flex flex justify-center"}>
                    <Sort data={data} sortKey={"price"}  onSort={(e)=> handleSort(e)}/>
                    {t("expire")}
                  </div>
                </th>
              </tr>
              </thead>
              <tbody>
              {data.map((item, index) => (
                <tr key={index} className="bg-white border-b border-gray-400">
                  <td className="px-6 py-4 text-center">
                    <div className={"text-gray-500 text-sm mt-1"}>
                      {item.row}
                    </div>
                  </td>
                  <td className=" py-4 text-start text-primary-400 text-base font-medium w-1/5">
                    <div className={"mt-1"}>
                      {item.code}
                    </div>
                  </td>

                  <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                    <div className={"mt-1 flex justify-center"}>
                      {item.eg}
                    </div>
                  </td>
                  <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                    <div className={"mt-1 flex justify-center"}>
                      {item.date}
                    </div>
                  </td>

                  <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                    <div className={"mt-1 flex justify-center"}>
                      {item.date}
                    </div>
                  </td>
                  <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                    <div className={"mt-1 flex justify-center"}>
                      {handleStatus(item.status)}
                    </div>
                  </td>
                  <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                    <div className={"mt-1 flex justify-center"}>
                      {item.date}
                    </div>
                  </td>

                </tr>
              ))}
              </tbody>
            </table>
          </div>
          :
          <div className={"grid gap-3 mt-3"}>
            <div className={"bg-white p-3 rounded-lg flex gap-5"}>
              <Filter/>
              <div className={"w-full"}>
                <Search onChange={handleSearch}/>
              </div>
            </div>
            {
              data?.map((item) => {
                return (
                  <div className={"flex p-4 rounded-lg bg-white"}>
                    <div className={"flex w-full"}>
                      <div className={"mx-1 min-w-7"}>{item.row}</div>
                      <div className={"flex w-full flex-wrap gap-y-8 justify-between"}>
                        <div className={"flex w-full justify-between"}>
                          <div className={"flex w-1/2 flex-col"}>
                            {item.code}
                          </div>
                          <div className={"flex w-1/2 justify-end text-end text-sm"}>{item.eg}</div>
                        </div>
                        <div className={"flex w-full justify-between items-center"}>
                          <div className={"flex w-1/4 text-sm text-gray-900 text-center justify-end"}>
                            {handleStatus(item.status)}
                          </div>
                          <div className={"flex w-1/3 text-sm text-gray-900 justify-end text-end"}>{item.name}</div>

                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
      }
      <div className={'flex flex-col  md:flex-row md:items-center md:justify-between mt-4'}>
        <DropDown/>
        <Pagination itemsPerPage={5} total={15} changePage={(page) => console.log(page)}/>
      </div>
    </div>
  );
};



export default VisaTableHistory;

